import {config as numberPercentColumnConfig} from '../../common/NumberPercentColumn';

export const prop = 'rATOD';
export const id = 'reviewerOverdueColumn';

export const config = (labels) =>
	numberPercentColumnConfig({
		fullId: id,
		label: labels.overdueLabel,
		prop,
		getPartial: (item) => item[prop],
		getTotal: (item) => item['rA'],
		width: 'minmax(var(--px-130), 1fr)'
	});
